
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.5.172v3.161c0 .708 0 1.667.5 2.167.5.5 1.459.5 2.166.5h3.226c.072.212.108.435.108.66V18.9c0 .557-.224 1.091-.622 1.485a2.138 2.138 0 01-1.503.615H2.625a2.138 2.138 0 01-1.503-.615A2.087 2.087 0 01.5 18.9V2.1c0-.557.224-1.091.622-1.485A2.138 2.138 0 012.625 0h8.033c.292 0 .578.06.842.172zM4.5 10a1 1 0 011-1h7a1 1 0 110 2h-7a1 1 0 01-1-1zm1 4a1 1 0 100 2h6a1 1 0 100-2h-6z","fill":"#368DF7"}})])
          )
        }
      }
    